import React from "react";
import t from "../../../../../../i18n";
import { comparatorBy } from "diagnostics-lib/comparator";
import type { Categories } from "./FilesType";
import AdditionnalMessage from "@ui/AdditionnalMessage";
import Details from "@ui/Details";
import { css } from "@linaria/core";
import { translationLocale } from "../../../../../../i18n/locale";

const NewCategoryList = css`
  list-style-type: disc;
  padding-left: 3rem;
`;

const NewCategoryDetails = css`
  padding-left: 24px;
`;
const namingCategories: Partial<Record<Categories, string>> = {
  system: t("setup.paragraphs.quantities.table.definitions.column.system"),
  equipmentType: t("setup.paragraphs.quantities.table.definitions.column.equipmentType"),
  degradationType: t("setup.paragraphs.failures.table.definitions.column.degradationType"),
  failureCategory: t("setup.paragraphs.failures.table.definitions.column.failureCategory"),
  equipments: t("setup.paragraphs.quantities.table.definitions.column.equipments"),
  suspectedElements: t("administration.failures.table.header.suspectedElements"),
};

interface NewCategoryInfoProps {
  toCreate: { column: Categories; values: string[] }[];
}

export const ImportNewCategoryInfo = ({ toCreate }: NewCategoryInfoProps) => {
  if (toCreate.length === 0) return null;

  return (
    <>
      <AdditionnalMessage status="INFO" text={t("setup.diagnosis.failure.import.new_categories")} />
      <Details
        className={NewCategoryDetails}
        summary={t("setup.diagnosis.failure.import.new_categories.summary")}
        text={
          <ul className={NewCategoryList}>
            {toCreate.sort(comparatorBy("column")).map(m => (
              <li key={m.column}>
                {namingCategories[m.column as Categories]}
                {translationLocale === "fr" ? " " : ""}: {m.values.join(", ")}
              </li>
            ))}
          </ul>
        }
      />
    </>
  );
};
